import { HostBackend } from '../../Routes/HostBackend.js';

export const Logout = () => {
    const backend = HostBackend();
    const handleLogout = async () => {
        const res = await fetch(`${backend}/auth/admin/logout`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        });
        const datas = await res.json();
        if (datas.msg) {
            sessionStorage.removeItem('token');
            window.location.href = '/admin/login';
        }
    }
    return (
        <div className="button-logout">
            <button className="button" onClick={() => { handleLogout() }}>
                <i className="fa fa-power-off"></i>
            </button>
        </div>
    )
}